import { LANGUAGE_LOCALES } from 'utils/constants';

export const baseLanguages = Object.values(LANGUAGE_LOCALES);

export enum LAYOUT_VARIABLES {
  headerVerticalPadding = '--header-vertical-padding',
  headerLogoHeight = '--header-logo-height',
  headerHeight = '--header-height',
}
